import pickBy from 'lodash/pickBy';

import { parse, stringify } from '../../../util/urlHelpers';

export const redirectToURLWithoutModalState = (navigate, location, modalStateParam) => {
  const { pathname, search, state } = location;
  const queryParams = pickBy(parse(search), (v, k) => {
    return k !== modalStateParam;
  });
  const stringified = stringify(queryParams);
  const searchString = stringified ? `?${stringified}` : '';
  navigate(`${pathname}${searchString}`, { replace: true, state });
};

export const redirectToURLWithModalState = (navigate, location, modalStateParam) => {
  const { pathname, search, state } = location;
  const searchString = `?${stringify({ [modalStateParam]: 'open', ...parse(search) })}`;
  navigate(`${pathname}${searchString}`, { replace: true, state });
};
